import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiGetAppResponseBody } from '../../Apps';
import { useApi } from '~/lib/api/useApi';
import { appQueryKeyFactory } from '../../Apps/hooks/useAppQuery';
import { appsQueryKeyFactory } from '../../Apps/hooks/useAppsQuery';

export type IUseActivateWPPlaylistsMutationValues = {
  appId: string;
};

export const useActivateWPPlaylistsMutation = (): UseMutationResult<
  IApiGetAppResponseBody,
  unknown,
  IUseActivateWPPlaylistsMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) => api.wpPlaylists.activate(values.appId),
    onSuccess: async (updatedApp) => {
      queryClient.setQueryData(
        appQueryKeyFactory({
          appId: updatedApp._id,
        })!,
        updatedApp,
      );
      await queryClient.invalidateQueries({
        queryKey: appsQueryKeyFactory(),
      });
    },
  });
};
